import Style from './App.module.scss';
import Home from './Components/Home';

function App() {
  return (
    <div className={Style.app}>
    <Home/>
    </div>
  );
}

export default App;
